{
    "name": "Geeetech",
    "version": "01.10.00.01",
    "force_update": "0",
    "description": "Geeetech configurations",
    "machine_model_list": [
        {
            "name": "Geeetech Thunder",
            "sub_path": "machine/Geeetech Thunder.json"
        },
        {
            "name": "Geeetech Mizar M",
            "sub_path": "machine/Geeetech Mizar M.json"
        },
        {
            "name": "Geeetech Mizar S",
            "sub_path": "machine/Geeetech Mizar S.json"
        },
        {
            "name": "Geeetech Mizar Pro",
            "sub_path": "machine/Geeetech Mizar Pro.json"
        },
       {
            "name": "Geeetech Mizar Max",
            "sub_path": "machine/Geeetech Mizar Max.json"
        },
        {
            "name": "Geeetech Mizar",
            "sub_path": "machine/Geeetech Mizar.json"
        },
        {
            "name": "Geeetech A10 Pro",
            "sub_path": "machine/Geeetech A10 Pro.json"
        },
        {
            "name": "Geeetech A10 M",
            "sub_path": "machine/Geeetech A10 M.json"
        },
        {
            "name": "Geeetech A10 T",
            "sub_path": "machine/Geeetech A10 T.json"
        },
        {
            "name": "Geeetech A20",
            "sub_path": "machine/Geeetech A20.json"
        },
        {
            "name": "Geeetech A20 M",
            "sub_path": "machine/Geeetech A20 M.json"
        },
        {
            "name": "Geeetech A20 T",
            "sub_path": "machine/Geeetech A20 T.json"
        },
        {
            "name": "Geeetech A30 Pro",
            "sub_path": "machine/Geeetech A30 Pro.json"
        },
        {
            "name": "Geeetech A30 M",
            "sub_path": "machine/Geeetech A30 M.json"
        },
        {
            "name": "Geeetech A30 T",
            "sub_path": "machine/Geeetech A30 T.json"
        },
        {
            "name": "Geeetech M1",
            "sub_path": "machine/Geeetech M1.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "fdm_process_geeetech_common",
            "sub_path": "process/fdm_process_geeetech_common.json"
        },
        {
            "name": "fdm_process_Geeetech_HS",
            "sub_path": "process/fdm_process_Geeetech_HS.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.08",
            "sub_path": "process/fdm_process_Geeetech_HS_0.08.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.08_nozzle_0.2",
            "sub_path": "process/fdm_process_Geeetech_HS_0.08_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.10",
            "sub_path": "process/fdm_process_Geeetech_HS_0.10.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.10_nozzle_0.2",
            "sub_path": "process/fdm_process_Geeetech_HS_0.10_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.12_nozzle_0.2",
            "sub_path": "process/fdm_process_Geeetech_HS_0.12_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.14_nozzle_0.2",
            "sub_path": "process/fdm_process_Geeetech_HS_0.14_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.16",
            "sub_path": "process/fdm_process_Geeetech_HS_0.16.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.20",
            "sub_path": "process/fdm_process_Geeetech_HS_0.20.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.24_nozzle_0.6",
            "sub_path": "process/fdm_process_Geeetech_HS_0.24_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.30_nozzle_0.6",
            "sub_path": "process/fdm_process_Geeetech_HS_0.30_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.25",
            "sub_path": "process/fdm_process_Geeetech_HS_0.25.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.36_nozzle_0.6",
            "sub_path": "process/fdm_process_Geeetech_HS_0.36_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.36_nozzle_0.8",
            "sub_path": "process/fdm_process_Geeetech_HS_0.36_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_Geeetech_HS_0.44_nozzle_0.8",
            "sub_path": "process/fdm_process_Geeetech_HS_0.44_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_geeetech_0.06_nozzle_0.2",
            "sub_path": "process/fdm_process_geeetech_0.06_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_geeetech_0.08",
            "sub_path": "process/fdm_process_geeetech_0.08.json"
        },
        {
            "name": "fdm_process_geeetech_0.08_nozzle_0.2",
            "sub_path": "process/fdm_process_geeetech_0.08_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_geeetech_0.10_nozzle_0.2",
            "sub_path": "process/fdm_process_geeetech_0.10_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_geeetech_0.12",
            "sub_path": "process/fdm_process_geeetech_0.12.json"
        },
        {
            "name": "fdm_process_geeetech_0.12_nozzle_0.2",
            "sub_path": "process/fdm_process_geeetech_0.12_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_geeetech_0.14_nozzle_0.2",
            "sub_path": "process/fdm_process_geeetech_0.14_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_geeetech_0.16",
            "sub_path": "process/fdm_process_geeetech_0.16.json"
        },
        {
            "name": "fdm_process_geeetech_0.18_nozzle_0.6",
            "sub_path": "process/fdm_process_geeetech_0.18_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_geeetech_0.20",
            "sub_path": "process/fdm_process_geeetech_0.20.json"
        },
        {
            "name": "fdm_process_geeetech_0.24",
            "sub_path": "process/fdm_process_geeetech_0.24.json"
        },
        {
            "name": "fdm_process_geeetech_0.24_nozzle_0.6",
            "sub_path": "process/fdm_process_geeetech_0.24_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_geeetech_0.24_nozzle_0.8",
            "sub_path": "process/fdm_process_geeetech_0.24_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_geeetech_0.28",
            "sub_path": "process/fdm_process_geeetech_0.28.json"
        },
        {
            "name": "fdm_process_geeetech_0.30_nozzle_0.6",
            "sub_path": "process/fdm_process_geeetech_0.30_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_geeetech_0.32_nozzle_0.8",
            "sub_path": "process/fdm_process_geeetech_0.32_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_geeetech_0.36_nozzle_0.6",
            "sub_path": "process/fdm_process_geeetech_0.36_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_geeetech_0.40_nozzle_0.8",
            "sub_path": "process/fdm_process_geeetech_0.40_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_geeetech_0.42_nozzle_0.6",
            "sub_path": "process/fdm_process_geeetech_0.42_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_geeetech_0.48_nozzle_0.8",
            "sub_path": "process/fdm_process_geeetech_0.48_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_geeetech_0.56_nozzle_0.8",
            "sub_path": "process/fdm_process_geeetech_0.56_nozzle_0.8.json"
        },
        {
            "name": "0.06mm Fine @Geeetech common 0.2 nozzle",
            "sub_path": "process/0.06mm Fine @Geeetech common 0.2 nozzle.json"
        },
        {
            "name": "0.08mm Extra Fine @Geeetech common",
            "sub_path": "process/0.08mm Extra Fine @Geeetech common.json"
        },
        {
            "name": "0.08mm Extra Fine @Geeetech Thunder",
            "sub_path": "process/0.08mm Extra Fine @Geeetech Thunder.json"
        },
        {
            "name": "0.08mm Optimal @Geeetech common 0.2 nozzle",
            "sub_path": "process/0.08mm Optimal @Geeetech common 0.2 nozzle.json"
        },
        {
            "name": "0.08mm Optimal @Geeetech Thunder 0.2 nozzle",
            "sub_path": "process/0.08mm Optimal @Geeetech Thunder 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Fine @Geeetech Thunder",
            "sub_path": "process/0.10mm Fine @Geeetech Thunder.json"
        },
        {
            "name": "0.10mm Standard @Geeetech common 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @Geeetech common 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Standard @Geeetech Thunder 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @Geeetech Thunder 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Draft @Geeetech common 0.2 nozzle",
            "sub_path": "process/0.12mm Draft @Geeetech common 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Draft @Geeetech Thunder 0.2 nozzle",
            "sub_path": "process/0.12mm Draft @Geeetech Thunder 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Fine @Geeetech common",
            "sub_path": "process/0.12mm Fine @Geeetech common.json"
        },
        {
            "name": "0.14mm Extra Draft @Geeetech common 0.2 nozzle",
            "sub_path": "process/0.14mm Extra Draft @Geeetech common 0.2 nozzle.json"
        },
        {
            "name": "0.14mm Extra Draft @Geeetech Thunder 0.2 nozzle",
            "sub_path": "process/0.14mm Extra Draft @Geeetech Thunder 0.2 nozzle.json"
        },
        {
            "name": "0.16mm Optimal @Geeetech common",
            "sub_path": "process/0.16mm Optimal @Geeetech common.json"
        },
        {
            "name": "0.16mm Optimal @Geeetech Thunder",
            "sub_path": "process/0.16mm Optimal @Geeetech Thunder.json"
        },
        {
            "name": "0.18mm Fine @Geeetech common 0.6 nozzle",
            "sub_path": "process/0.18mm Fine @Geeetech common 0.6 nozzle.json"
        },
        {
            "name": "0.20mm Standard @Geeetech common",
            "sub_path": "process/0.20mm Standard @Geeetech common.json"
        },
        {
            "name": "0.20mm Standard @Geeetech Thunder",
            "sub_path": "process/0.20mm Standard @Geeetech Thunder.json"
        },
        {
            "name": "0.20mm Strength @Geeetech common",
            "sub_path": "process/0.20mm Strength @Geeetech common.json"
        },
        {
            "name": "0.24mm Draft @Geeetech common",
            "sub_path": "process/0.24mm Draft @Geeetech common.json"
        },
        {
            "name": "0.24mm Fine @Geeetech common 0.8 nozzle",
            "sub_path": "process/0.24mm Fine @Geeetech common 0.8 nozzle.json"
        },
        {
            "name": "0.24mm Optimal @Geeetech common 0.6 nozzle",
            "sub_path": "process/0.24mm Optimal @Geeetech common 0.6 nozzle.json"
        },
        {
            "name": "0.24mm Optimal @Geeetech Thunder 0.6 nozzle",
            "sub_path": "process/0.24mm Optimal @Geeetech Thunder 0.6 nozzle.json"
        },
        {
            "name": "0.25mm Draft @Geeetech Thunder",
            "sub_path": "process/0.25mm Draft @Geeetech Thunder.json"
        },
        {
            "name": "0.28mm Extra Draft @Geeetech common",
            "sub_path": "process/0.28mm Extra Draft @Geeetech common.json"
        },
        {
            "name": "0.30mm Standard @Geeetech common 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Geeetech common 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Geeetech Thunder 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Geeetech Thunder 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Strength @Geeetech common 0.6 nozzle",
            "sub_path": "process/0.30mm Strength @Geeetech common 0.6 nozzle.json"
        },
        {
            "name": "0.32mm Optimal @Geeetech common 0.8 nozzle",
            "sub_path": "process/0.32mm Optimal @Geeetech common 0.8 nozzle.json"
        },
        {
            "name": "0.36mm Draft @Geeetech common 0.6 nozzle",
            "sub_path": "process/0.36mm Draft @Geeetech common 0.6 nozzle.json"
        },
        {
            "name": "0.36mm Draft @Geeetech Thunder 0.6 nozzle",
            "sub_path": "process/0.36mm Draft @Geeetech Thunder 0.6 nozzle.json"
        },
        {
            "name": "0.36mm Optimal @Geeetech Thunder 0.8 nozzle",
            "sub_path": "process/0.36mm Optimal @Geeetech Thunder 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @Geeetech common 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Geeetech common 0.8 nozzle.json"
        },
        {
            "name": "0.42mm Extra Draft @Geeetech common 0.6 nozzle",
            "sub_path": "process/0.42mm Extra Draft @Geeetech common 0.6 nozzle.json"
        },
        {
            "name": "0.44mm Draft @Geeetech Thunder 0.8 nozzle",
            "sub_path": "process/0.44mm Draft @Geeetech Thunder 0.8 nozzle.json"
        },
        {
            "name": "0.48mm Draft @Geeetech common 0.8 nozzle",
            "sub_path": "process/0.48mm Draft @Geeetech common 0.8 nozzle.json"
        },
        {
            "name": "0.56mm Extra Draft @Geeetech common 0.8 nozzle",
            "sub_path": "process/0.56mm Extra Draft @Geeetech common 0.8 nozzle.json"
        },
        {
            "name": "0.08mm Extra Fine @Geeetech M1",
            "sub_path": "process/0.08mm Extra Fine @Geeetech M1.json"
        },
        {
            "name": "0.08mm Optimal @Geeetech M1 0.2 nozzle",
            "sub_path": "process/0.08mm Optimal @Geeetech M1 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Fine @Geeetech M1",
            "sub_path": "process/0.10mm Fine @Geeetech M1.json"
        },
        {
            "name": "0.10mm Standard @Geeetech M1 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @Geeetech M1 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Draft @Geeetech M1 0.2 nozzle",
            "sub_path": "process/0.12mm Draft @Geeetech M1 0.2 nozzle.json"
        },
        {
            "name": "0.14mm Extra Draft @Geeetech M1 0.2 nozzle",
            "sub_path": "process/0.14mm Extra Draft @Geeetech M1 0.2 nozzle.json"
        },
        {
            "name": "0.16mm Optimal @Geeetech M1",
            "sub_path": "process/0.16mm Optimal @Geeetech M1.json"
        },
        {
            "name": "0.20mm Standard @Geeetech M1",
            "sub_path": "process/0.20mm Standard @Geeetech M1.json"
        },
        {
            "name": "0.24mm Optimal @Geeetech M1 0.6 nozzle",
            "sub_path": "process/0.24mm Optimal @Geeetech M1 0.6 nozzle.json"
        },
        {
            "name": "0.25mm Draft @Geeetech M1",
            "sub_path": "process/0.25mm Draft @Geeetech M1.json"
        },
        {
            "name": "0.30mm Standard @Geeetech M1 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Geeetech M1 0.6 nozzle.json"
        },
        {
            "name": "0.36mm Draft @Geeetech M1 0.6 nozzle",
            "sub_path": "process/0.36mm Draft @Geeetech M1 0.6 nozzle.json"
        },
        {
            "name": "0.36mm Optimal @Geeetech M1 0.8 nozzle",
            "sub_path": "process/0.36mm Optimal @Geeetech M1 0.8 nozzle.json"
        },
        {
            "name": "0.44mm Draft @Geeetech M1 0.8 nozzle",
            "sub_path": "process/0.44mm Draft @Geeetech M1 0.8 nozzle.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_asa",
            "sub_path": "filament/fdm_filament_asa.json"
        },
        {
            "name": "fdm_filament_pa",
            "sub_path": "filament/fdm_filament_pa.json"
        },
        {
            "name": "fdm_filament_pc",
            "sub_path": "filament/fdm_filament_pc.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_pva",
            "sub_path": "filament/fdm_filament_pva.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "fdm_filament_tpu",
            "sub_path": "filament/fdm_filament_tpu.json"
        },
        {
            "name": "Generic ABS @Geeetech",
            "sub_path": "filament/Generic ABS @Geeetech.json"
        },
        {
            "name": "Generic ASA @Geeetech",
            "sub_path": "filament/Generic ASA @Geeetech.json"
        },
        {
            "name": "Generic PA @Geeetech",
            "sub_path": "filament/Generic PA @Geeetech.json"
        },
        {
            "name": "Generic PC @Geeetech",
            "sub_path": "filament/Generic PC @Geeetech.json"
        },
        {
            "name": "Generic PETG @Geeetech",
            "sub_path": "filament/Generic PETG @Geeetech.json"
        },
        {
            "name": "Generic PLA @Geeetech",
            "sub_path": "filament/Generic PLA @Geeetech.json"
        },
        {
            "name": "Generic PLA @Geeetech_FastSpeed",
            "sub_path": "filament/Generic PLA @Geeetech_FastSpeed.json"
        },
        {
            "name": "Generic PLA-CF @Geeetech",
            "sub_path": "filament/Generic PLA-CF @Geeetech.json"
        },
        {
            "name": "Generic PVA @Geeetech",
            "sub_path": "filament/Generic PVA @Geeetech.json"
        },
        {
            "name": "Generic TPU @Geeetech",
            "sub_path": "filament/Generic TPU @Geeetech.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "fdm_geeetech_common",
            "sub_path": "machine/fdm_geeetech_common.json"
        },
        {
            "name": "fdm_Geeetech_HS_common",
            "sub_path": "machine/fdm_Geeetech_HS_common.json"
        },
        {
            "name": "Geeetech Thunder 0.2 nozzle",
            "sub_path": "machine/Geeetech Thunder 0.2 nozzle.json"
        },
        {
            "name": "Geeetech Thunder 0.4 nozzle",
            "sub_path": "machine/Geeetech Thunder 0.4 nozzle.json"
        },
        {
            "name": "Geeetech Thunder 0.6 nozzle",
            "sub_path": "machine/Geeetech Thunder 0.6 nozzle.json"
        },
        {
            "name": "Geeetech Thunder 0.8 nozzle",
            "sub_path": "machine/Geeetech Thunder 0.8 nozzle.json"
        },
        {
            "name": "Geeetech Mizar 0.2 nozzle",
            "sub_path": "machine/Geeetech Mizar 0.2 nozzle.json"
        },
        {
            "name": "Geeetech Mizar 0.4 nozzle",
            "sub_path": "machine/Geeetech Mizar 0.4 nozzle.json"
        },
        {
            "name": "Geeetech Mizar 0.6 nozzle",
            "sub_path": "machine/Geeetech Mizar 0.6 nozzle.json"
        },
        {
            "name": "Geeetech Mizar 0.8 nozzle",
            "sub_path": "machine/Geeetech Mizar 0.8 nozzle.json"
        },
        {
            "name": "Geeetech Mizar S 0.2 nozzle",
            "sub_path": "machine/Geeetech Mizar S 0.2 nozzle.json"
        },
        {
            "name": "Geeetech Mizar S 0.4 nozzle",
            "sub_path": "machine/Geeetech Mizar S 0.4 nozzle.json"
        },
        {
            "name": "Geeetech Mizar S 0.6 nozzle",
            "sub_path": "machine/Geeetech Mizar S 0.6 nozzle.json"
        },
        {
            "name": "Geeetech Mizar S 0.8 nozzle",
            "sub_path": "machine/Geeetech Mizar S 0.8 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Pro 0.2 nozzle",
            "sub_path": "machine/Geeetech Mizar Pro 0.2 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Pro 0.4 nozzle",
            "sub_path": "machine/Geeetech Mizar Pro 0.4 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Pro 0.6 nozzle",
            "sub_path": "machine/Geeetech Mizar Pro 0.6 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Pro 0.8 nozzle",
            "sub_path": "machine/Geeetech Mizar Pro 0.8 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Max 0.2 nozzle",
            "sub_path": "machine/Geeetech Mizar Max 0.2 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Max 0.4 nozzle",
            "sub_path": "machine/Geeetech Mizar Max 0.4 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Max 0.6 nozzle",
            "sub_path": "machine/Geeetech Mizar Max 0.6 nozzle.json"
        },
        {
            "name": "Geeetech Mizar Max 0.8 nozzle",
            "sub_path": "machine/Geeetech Mizar Max 0.8 nozzle.json"
        },
        {
            "name": "Geeetech Mizar M 0.4 nozzle",
            "sub_path": "machine/Geeetech Mizar M 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A10 Pro 0.2 nozzle",
            "sub_path": "machine/Geeetech A10 Pro 0.2 nozzle.json"
        },
        {
            "name": "Geeetech A10 Pro 0.4 nozzle",
            "sub_path": "machine/Geeetech A10 Pro 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A10 Pro 0.6 nozzle",
            "sub_path": "machine/Geeetech A10 Pro 0.6 nozzle.json"
        },
        {
            "name": "Geeetech A10 Pro 0.8 nozzle",
            "sub_path": "machine/Geeetech A10 Pro 0.8 nozzle.json"
        },
        {
            "name": "Geeetech A10 M 0.4 nozzle",
            "sub_path": "machine/Geeetech A10 M 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A10 T 0.4 nozzle",
            "sub_path": "machine/Geeetech A10 T 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A20 0.2 nozzle",
            "sub_path": "machine/Geeetech A20 0.2 nozzle.json"
        },
        {
            "name": "Geeetech A20 0.4 nozzle",
            "sub_path": "machine/Geeetech A20 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A20 0.6 nozzle",
            "sub_path": "machine/Geeetech A20 0.6 nozzle.json"
        },
        {
            "name": "Geeetech A20 0.8 nozzle",
            "sub_path": "machine/Geeetech A20 0.8 nozzle.json"
        },
        {
            "name": "Geeetech A20 M 0.4 nozzle",
            "sub_path": "machine/Geeetech A20 M 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A20 T 0.4 nozzle",
            "sub_path": "machine/Geeetech A20 T 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A30 Pro 0.2 nozzle",
            "sub_path": "machine/Geeetech A30 Pro 0.2 nozzle.json"
        },
        {
            "name": "Geeetech A30 Pro 0.4 nozzle",
            "sub_path": "machine/Geeetech A30 Pro 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A30 Pro 0.6 nozzle",
            "sub_path": "machine/Geeetech A30 Pro 0.6 nozzle.json"
        },
        {
            "name": "Geeetech A30 Pro 0.8 nozzle",
            "sub_path": "machine/Geeetech A30 Pro 0.8 nozzle.json"
        },
        {
            "name": "Geeetech A30 M 0.4 nozzle",
            "sub_path": "machine/Geeetech A30 M 0.4 nozzle.json"
        },
        {
            "name": "Geeetech A30 T 0.4 nozzle",
            "sub_path": "machine/Geeetech A30 T 0.4 nozzle.json"
        },
        {
            "name": "Geeetech M1 0.2 nozzle",
            "sub_path": "machine/Geeetech M1 0.2 nozzle.json"
        },
        {
            "name": "Geeetech M1 0.4 nozzle",
            "sub_path": "machine/Geeetech M1 0.4 nozzle.json"
        },
        {
            "name": "Geeetech M1 0.6 nozzle",
            "sub_path": "machine/Geeetech M1 0.6 nozzle.json"
        },
        {
            "name": "Geeetech M1 0.8 nozzle",
            "sub_path": "machine/Geeetech M1 0.8 nozzle.json"
        }
    ]
}